"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _customPropTypes = require("../helpers/customPropTypes");

var _Button = require("../Button");

var _Button2 = _interopRequireDefault(_Button);

var _Icon = require("../Icon");

var _Icon2 = _interopRequireDefault(_Icon);

require("./Toast.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var iconTypes = {
  success: "check",
  warning: "caution",
  error: "exclamation-circle",
  info: "info-circle",
  locked: "lock",
  "visually-hidden": "info-circle"
};

var minimumCloseTimeout = 1500;

var defaultIsOpen = true;

var Toast = function (_PureComponent) {
  _inherits(Toast, _PureComponent);

  function Toast(props) {
    _classCallCheck(this, Toast);

    var _this = _possibleConstructorReturn(this, (Toast.__proto__ || Object.getPrototypeOf(Toast)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      isOpen: _this.isOpen
    };
    return _this;
  }

  _createClass(Toast, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoclose) {
        this.autoDismiss(this.props.autocloseTimeout);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!this.isOpen && this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
      if (!this.timeoutId && this.props.autoclose && this.isOpen) {
        this.autoDismiss(this.props.autocloseTimeout);
      }
      if (this.getIsOpen(prevProps) !== this.isOpen) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeoutId);
    }

    // Deprecation of open prop

  }, {
    key: "autoDismiss",
    value: function autoDismiss(autocloseTimeout) {
      var _this2 = this;

      this.timeoutId = setTimeout(function () {
        _this2.handleClose();
      }, Math.max(autocloseTimeout, minimumCloseTimeout));
    }
  }, {
    key: "renderCloseButton",
    value: function renderCloseButton() {
      if (this.props.hasCloseButton) {
        return _react2.default.createElement(_Button2.default, {
          ariaLabel: this.context.t("close"),
          className: "aclui-toast__close",
          isCloseButton: true,
          onClick: this.handleClose,
          size: "small"
        });
      }
      return "";
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.isOpen) return null;

      /* eslint-disable no-unused-vars */
      /**
       * Destructuring is used to isolate additional props in moreProps and pass them along to
       * Toast component.  Some are not used here in render(), but are used above and so must
       * remain in this statement to exclude them from moreProps.
       */

      var _props = this.props,
          ariaAlert = _props.ariaAlert,
          autoclose = _props.autoclose,
          autocloseTimeout = _props.autocloseTimeout,
          children = _props.children,
          className = _props.className,
          hasCloseButton = _props.hasCloseButton,
          isOpen = _props.isOpen,
          open = _props.open,
          onClosed = _props.onClosed,
          sticky = _props.sticky,
          type = _props.type,
          zIndex = _props.zIndex,
          moreProps = _objectWithoutProperties(_props, ["ariaAlert", "autoclose", "autocloseTimeout", "children", "className", "hasCloseButton", "isOpen", "open", "onClosed", "sticky", "type", "zIndex"]);
      /* eslint-enable no-unused-vars */

      var ariaLive = ariaAlert ? "assertive" : "polite";
      var rootClasses = (0, _classnames2.default)("aclui-toast", "aclui-toast--" + type, { "aclui-toast--sticky": sticky }, { "aclui-toast--has-close-button": hasCloseButton }, className);

      return _react2.default.createElement(
        "div",
        _extends({ className: rootClasses, role: "alert", "aria-live": ariaLive, style: { zIndex: zIndex } }, moreProps),
        _react2.default.createElement(_Icon2.default, { className: "aclui-toast__icon", type: iconTypes[type], size: 20 }),
        _react2.default.createElement(
          "div",
          { className: "aclui-toast__content" },
          children
        ),
        this.renderCloseButton()
      );
    }
  }, {
    key: "isOpen",
    get: function get() {
      return this.getIsOpen();
    }
  }]);

  return Toast;
}(_react.PureComponent);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getIsOpen = function (props) {
    var _ref = props || _this3.props,
        isOpen = _ref.isOpen,
        open = _ref.open;

    if (isOpen === null && open === undefined) return defaultIsOpen;
    return isOpen || open;
  };

  this.handleOpen = function () {
    _this3.setState({ isOpen: _this3.isOpen });
  };

  this.handleClose = function () {
    if (_this3.timeoutId) {
      clearTimeout(_this3.timeoutId);
      _this3.timeoutId = null;
    }

    _this3.setState({ isOpen: false });

    // Note: this will run before the state has changed.
    _this3.props.onClosed();
  };
};

Toast.contextTypes = {
  t: _propTypes2.default.func.isRequired
};

Toast.propTypes = {
  /**
   * Will make this an "assertive" alert that will interrupt immediately.
   * Default behaviour is to be "polite" and wait until the user is idle.
   */
  ariaAlert: _propTypes2.default.bool,

  /** Will automatically close after 1500ms (or longer if provided by autocloseTimeout) */
  autoclose: _propTypes2.default.bool,

  /** Duration (in ms) before Toast will automaticall close (if autoclose is true) */
  autocloseTimeout: _propTypes2.default.number,

  /** Content of the Toast */
  children: _propTypes2.default.node,

  /** A custom class to add to the root node */
  className: _propTypes2.default.string,

  /** If the component should have a 'close' button */
  hasCloseButton: _propTypes2.default.bool,

  /**
   * If the Toast should be initially visible.
   * open prop is deprecated. Use isOpen instead.
   */
  isOpen: _propTypes2.default.bool,
  open: (0, _customPropTypes.deprecated)("isOpen"),

  /** Callback that is executed after clicking the 'close' button */
  onClosed: _propTypes2.default.func,

  /** If the Toast is fixed to the top of the viewport */
  sticky: _propTypes2.default.bool,

  /** Determines the styling of the Toast */
  type: _propTypes2.default.oneOf(["success", "warning", "error", "info", "locked", "visually-hidden"]),

  /** The z-index of the Toast */
  zIndex: _propTypes2.default.number
};

Toast.defaultProps = {
  ariaAlert: false,
  autoclose: false,
  autocloseTimeout: 5000,
  className: null,
  hasCloseButton: true,
  isOpen: null, // default value defined above by defaultIsOpen
  open: undefined, // deprecated
  onClosed: function onClosed() {},
  sticky: false,
  type: "info",
  zIndex: 1006 // Results uses something at 1005 – TODO: fix Results
};

exports.default = Toast;